/*
 * Description: UrlMapping后台接口
 * Author: chaoge
 * Date: 2018/05/23
 */

export default class UrlMapping {
  constructor() {
    // this.isLocalHost = window.location.host.toLowerCase() == 'localhost:8080';
    this.origin = window.location.origin;
    this.isLocalHost = true;

    this.POST_SITE_FINDALLSITELIST = (this.isLocalHost ? '/site/apis' : this.origin) + '/api/site/findAllSiteList'; // 全国门店
    this.POST_SITE_FINDPROVINCESITELIST = (this.isLocalHost ? '/site/apis' : this.origin) + '/api/site/findProvinceSiteList'; // 城市门店
   
  }

}



// WEBPACK FOOTER //
// ./src/assets/js/UrlMapping.js